import {Injectable} from '@angular/core';
import {Observable} from 'rxjs';
import {Schedule} from '../../shared/models/schedule';
import {HttpClient} from '@angular/common/http';
import {API_BASE_URL} from './env.service';
import { TileId } from 'src/shared/models/tile';

@Injectable({
  providedIn: 'root',
})
export class SchedulesService {

  constructor(
    private http: HttpClient,
  ) {
  }


  fetchSchedules$(tileId: TileId): Observable<Schedule[]> {
    return new Observable<Schedule[]>((subscriber) => {
      this.http.get<Schedule[]>(`${API_BASE_URL}/schedules`, {
        params: {
          TileID: '' + tileId,
        },
      }).subscribe(
        (schedules) => {
          subscriber.next(schedules);
          subscriber.complete();
        }, () => {
          subscriber.error();
        },
      );
    });
  }


  createSchedule$(schedule: Schedule): Observable<Schedule> {
    return new Observable<Schedule>((subscriber) => {
      this.http.post<Schedule>(`${API_BASE_URL}/schedules`, schedule).subscribe(
        (schedule) => {
          subscriber.next(schedule);
          subscriber.complete();
        },
        () => {
          subscriber.error();
        },
      );
    });
  }


  /**
   *
   * @param schedule
   */
  updateSchedule$(schedule: Schedule): Observable<Schedule> {
    return new Observable<Schedule>((subscriber) => {
      this.http.put<Schedule>(`${API_BASE_URL}/schedules`, schedule).subscribe(
        (schedule) => {
          subscriber.next(schedule);
          subscriber.complete();
        },
        () => {
          subscriber.error();
        },
      );
    });
  }


  /**
   *
   * @param uuid
   */
  deleteSchedule$(uuid: string): Observable<boolean> {
    return new Observable<boolean>((subscriber) => {
      this.http.delete(`${API_BASE_URL}/schedules/${uuid}`).subscribe(
        () => {
          subscriber.next(true);
          subscriber.complete();
        },
        () => {
          subscriber.error();
        },
      );
    });
  }
}
